/* Keep storefront product links on the complete product template, including CMS links. */
(() => {
  if (window.JBProductLinks) return;
  const script = document.currentScript;
  const origins = new Set([location.origin]);
  [script?.dataset.shopUrl, script?.dataset.shopDomain].forEach(value => {
    if (!value) return;
    try { origins.add(new URL(value, location.origin).origin); } catch (_) {}
  });
  function productURL(value) {
    if (!value || value.startsWith('#')) return null;
    let url;
    try { url = new URL(value, location.href); } catch (_) { return null; }
    if (!/^https?:$/.test(url.protocol) || !origins.has(url.origin)) return null;
    const match = url.pathname.match(/^((?:\/[a-z]{2}(?:-[a-z]{2})?)?)\/(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/i);
    if (!match || /\.(?:js|json|xml|html)$/i.test(match[2])) return null;
    try { if (decodeURIComponent(match[2]).includes('/')) return null; } catch (_) { return null; }
    url.pathname = match[1] + '/products/' + match[2];
    url.searchParams.set('view', 'jb');
    return url.pathname + url.search + url.hash;
  }
  function prepare(link) {
    if (!link || link.hasAttribute('download')) return;
    const next = productURL(link.getAttribute('href'));
    if (next && next !== link.getAttribute('href')) link.setAttribute('href', next);
  }
  function prepareTree(root) {
    if (root?.matches?.('a[href]')) prepare(root);
    root?.querySelectorAll?.('a[href*="/products/"]').forEach(prepare);
  }
  window.JBProductLinks = { url: productURL };
  // Capture runs before native navigation and before handlers that consume href.
  // Newly inserted recommendations and CMS content need no page-wide observer.
  ['pointerdown', 'focusin', 'contextmenu', 'click', 'auxclick'].forEach(type => {
    document.addEventListener(type, event => prepare(event.target.closest?.('a[href]')), { capture: true, passive: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareTree(document), { once: true });
  else prepareTree(document);
  document.addEventListener('shopify:section:load', event => prepareTree(event.target));
  document.addEventListener('jb:product-replaced', () => prepareTree(document.querySelector('.jb-product-experience')));
})();
